import { Component, OnInit, Input } from '@angular/core';
import { KeyValue } from '@angular/common';

import {
  ControlPropertySpecification,
  ControlSpecification,
  ControlValidatorSpecification
} from '../../types/specification.types';
import { AbstractControl } from '../../types/control.types';
import { ControlPropertyToolType } from '../../utils/control-property-tool-type.enum';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dy-property-grid',
  templateUrl: './property-grid.component.html',
  styleUrls: ['./property-grid.component.css']
})
export class PropertyGridComponent implements OnInit {
  @Input() disableEditEntityProperty: boolean;

  @Input()
  get control(): AbstractControl<any> {
    return this._control;
  }
  set control(value: AbstractControl<any>) {
    this._control = value;
  }

  @Input()
  get controlSpecification(): ControlSpecification {
    return this._controlSpecification;
  }
  set controlSpecification(value: ControlSpecification) {
    this._controlSpecification = value;
    if (value) {
      this.groupPropertySpecifications(value.properties);
    } else {
      this.propertyGroups.splice(0, this.propertyGroups.length);
    }
    this.resetValidators(value);
    this.selectProperty();
  }

  propertyGroups: Array<KeyValue<string, Array<ControlPropertySpecification>>> = [];

  validators: Array<ControlValidatorSpecification> = [];

  currentType: ControlPropertyToolType = ControlPropertyToolType.Property;

  propertyType = ControlPropertyToolType.Property;
  eventType = ControlPropertyToolType.Event;
  validatorType = ControlPropertyToolType.Validator;

  private _control: AbstractControl<any>;
  private _controlSpecification: ControlSpecification;

  constructor() {}

  ngOnInit() {}

  private groupPropertySpecifications(specifications: Array<ControlPropertySpecification>) {
    this.propertyGroups.splice(0, this.propertyGroups.length);
    const propertyGroups: Array<KeyValue<string, Array<ControlPropertySpecification>>> = [];

    if (specifications === undefined) {
      return;
    }

    for (const specification of specifications) {
      const groupName = specification.groupName;
      const filteredGroups = propertyGroups.filter((x) => x.key === groupName);
      let items: Array<ControlPropertySpecification>;

      if (filteredGroups.length === 0) {
        const groupItem = {
          key: groupName,
          value: new Array<ControlPropertySpecification>()
        };
        propertyGroups.push(groupItem);
        items = groupItem.value;
      } else {
        items = filteredGroups[0].value;
      }

      items.push(specification);
    }
    this.propertyGroups.push(...propertyGroups);
  }

  private resetValidators(value: ControlSpecification) {
    this.validators.splice(0, this.propertyGroups.length);
    if (value) {
      this.validators.push(...value.validators);
    }
  }

  selectProperty() {
    this.currentType = ControlPropertyToolType.Property;
  }

  selectEvent() {
    this.currentType = ControlPropertyToolType.Event;
  }

  selectValidator() {
    this.currentType = ControlPropertyToolType.Validator;
  }
}
